<template>
  <div class="accept-container read"
       v-title
       :data-title="urlTitle">
    <div class="read-header box">
      <div class="read-header-button">
        <div class="left read-button">
          <div class="back read-button-item"
               @click="back"></div>
          <div v-bind:class="['collotion','read-button-item',{'active':isCollection}]"
            @click="collection"></div>
        </div>
        <h2 class="read-title cyxy-trs-source">{{article.title}}</h2>
        <h2 class="read-title mobile-title">{{$t('title.all')}}{{$t('title.online')}}</h2>  
        <div
          @click="share"
          @mouseover="moveShare"
          v-bind:class="['right','read-button','read-button-item','-mob-share-ui-button','-mob-share-open','share',{'hover':article.public}]"></div>
        <div class="share-list"
             v-if="shareList">
          <Share :config="config"></Share>
        </div>
      </div>
    </div>
    <div>
      <iframe :src="src"
              width="100%"
              id="bdIframe"
              allowtransparency="true"
              frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
  // import wxApi from  '@/utils/wxshare';
  import {getArticle,USER_INFO,getArticlePublic,getUserData} from '@/api/user';
  import {CollectionPage,CancelCollection}from'@/api/doc';
  import $ from 'jquery';
  import Share from 'vue-social-share';
  import "../css/client.css";
  import {getSignature} from '@/api/weixin';



  export default {
    components:{Share},
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    },
    created() {
      this.userId = USER_INFO()._id;
      console.log(this.userId);
      this.id = this.$route.params.id;
      if(window.location.hostname ==='localhost'){
        this.src = 'http://localhost:8080/article/?iframe=true&id='+this.id;
      }else{
        this.src = '/article/?iframe=true&id='+this.id;
      }

      this.fetchData();
    },
    data() {
      return {
        article: {},
        totalH: '',
        clientH: '',
        classWidth: 0,
        id:0,
        isCollection:true,
        userId:'',
        src:'',
        config:{},
        shareList:false,
        urlTitle:this.$t('title.all')+this.$t('title.online')
      }
    },
    mounted(){
      this.screen();
    },
    methods: {
      screen: function () {
        const oIframe = document.getElementById('bdIframe');
        const deviceHeight = document.documentElement.clientHeight
        oIframe.style.height = ( deviceHeight > 600 ?  deviceHeight - 60 : 600 - 60 ) + 'px';
      },
      moveShare(){

      },
      share(){
        if(!this.article.public){
            getArticlePublic({
              article_id: this.id
            }).then(res=>{
                if(res.rc ==0){
                  this.article.public = true;
                  this.article.public_url = res.article.public_url;
                  this.shareList=true;
                }
            })
        }else{
          this.shareList=!this.shareList;
        }
      },
      back() {
        this.$router.push({path: '/mine/favorite'})
      },
      // ['qzone', 'qq', 'weibo','wechat', 'douban','google', 'facebook', 'twitter']
      fetchData(flag) {
        this.listLoading = true;
        getArticle({
          article_id: this.id
        }).then(response => {
          if(response.rc == 0){
            this.listLoading = false;
            this.article = response.article;
            console.log(this.article);
            getSignature({
              title:response.article['title'],
              img:response.article['img']  || "",
              url:'https://'+window.location.host + '/article/?id='+this.id,
            })
            document['title'] = this.$t('title.all')+this.article['title'];
           // this.urlTitle = '彩云小译 - '+this.article.title;
           this.config={
             url:'https://'+window.location.host + '/article/?id='+this.id,
             source:this.article.title,
             title:this.article.title,
             description:this.article.des,
             image:this.article.img  || 'https://www.caiyunapp.com/images/favorite-null.png',
             sites:['weibo','wechat'],
             disabled:[],
             wechatQrcodeTitle:this.$t('read.weixin[0]'),
             wechatQrcodeHelper  : '<p>'+this.$t('read.weixin[1]')+'</p><p>'+this.$t('read.weixin[2]')+'</p>'
           }
           window.addEventListener('scroll', this.handleScroll);
          }
        })
      },
      handleScroll(){
        this.totalH = document.body.scrollHeight || document.documentElement.scrollHeight;
        this.clientH = window.innerHeight || document.documentElement.clientHeight;
        var validH = this.totalH - this.clientH;
        var scrollH = document.body.scrollTop || document.documentElement.scrollTop;
        this.classWidth = (scrollH / validH * 100).toFixed(2);
      },
      collection () {
        let user =USER_INFO()._id;

        if(this.isCollection){
          CancelCollection(user,this.article.id)
            .then(res=>{
            if(res.rc ==0){
              this.isCollection = false;
            }
          })
        }else{
          CollectionPage(user,this.article.link)
            .then(res=>{
            if(res.rc==0){
              this.isCollection = true;
            }
          }).catch(err=>{
              console.log(err)
          })
        }
      }
    }
  }
</script>
<style scoped>

  .mobile-title{
    display: none;
  }
  >>> img{
    display: block;
    max-width:100%;
    margin: 0 auto;
  }
  iframe{
    display: block;
  }
  .read {
    padding-top: 60px;
  }

  body,html{
    height:100%;
  }
  .-mob-share-ui-button {
    display: block;
    text-align: center;
    cursor: pointer;
    background: #fff !important;
    color: #000 !important;
    font-size: inherit !important;
  }

  .content-html {
    line-height: 1.5;
    text-align: left;
    width: auto;
    margin: 0 auto 1.5em;
    color: #313131;
    padding-left: 20px;
    padding-right: 20px;
    -webkit-user-select: auto;
    -khtml-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
  }

  .content-title {
    color: #222;
    font-weight: 700;
    margin: 1em 0 0;
    font-size: 1.8em;
    line-height: 1.2;
    padding-bottom: .1em;
  }

  .read-title {
    color: #b1b2b2;
    font-size: 1.15385em;
    font-weight: 600;
    line-height: 60px;
    margin: 0 120px 0 120px;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-transition: opacity .2s ease-out;
    transition: opacity .2s ease-out;
    cursor: default;
  }

  .read-header-button {
    margin-left: 3.07692em;
    margin-right: 3.07692em;
    /* max-width: 109.23077em; */
    position: relative;
    height: 100%;
  }

  .read-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 35px;
  }

  .read-button-item {
    cursor: pointer;
    width: 35px;
    height: 35px;
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: cover !important;
    display: inline-block;
    padding: 0 !important;
  }

  .read-button-item.back {
    background-image: url('../assets/favorite-back.png');
    margin-right: 40px;
  }

  .read-button-item.collotion {
    background-image: url('../assets/favorite-coll.png');
  }

  .read-button-item.share {
    background-image: url('../assets/private.png') !important;
  }

  .read-button-item.back:hover {
    background-image: url('../assets/favorite-back-hover.png');
  }
  .read-button-item.collotion.active{
    background-image: url('../assets/favorite-coll-hover.png');
  }

  .read-button-item.collotion.active {
    background-image: url('../assets/favorite-coll-hover.png');
  }

  .read-button-item.share.hover {
    background-image: url('../assets/favorite-share-hover.png') !important;
  }

  .left {
    left: 0;
  }

  .right {
    right: 0;
  }

  .read-header {
    height: 60px;
    line-height: 60px;
    position: fixed;
    top: 0;
    z-index: 9999;
    width: 100%;
    background: #ffffff;
    -webkit-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
  }

  .progress-line {
    height: 2px;
    width: 0%;
    background: #5ebb8d;
    position: absolute;
  }

  .read-header .el-button {
    border: none;
  }

  .read-header .el-button:hover, .read-header .el-button:focus {
    color: #5ebb8d;
    border-color: inherit;
    background-color: inherit;
  }

  .read-content {
    max-width: 704px;
    margin: 0 auto;
    padding-bottom: 60px;
  }
  .read-content-box{
    height:100%;
    width:100%;
  }
  .share-list{
    position: absolute;
    right: -5px;
    top: 75px;
  }
  >>>.social-share .social-share-icon{
    display: block;
    width: 35px;
    height: 35px;
    line-height:  35px;
   }
   >>>.social-share .icon-wechat .wechat-qrcode {
      top: 0px;
      left: -210px;
  }
  >>>.social-share .icon-wechat .wechat-qrcode:after{
       content: '';
       position: absolute;
       top: 15px;
       right: -12px;
       transform: rotate(-90deg);
       bottom:auto;
       left:auto;
 }
  @media (max-width: 650px) {
    .read-header-button {
      margin-right: 20px;
      margin-left: 20px;
    }
    .read-button-item.back{
        margin-right: 8px;
    }
    .read-button.right{
      display: none;
    }
    .read-header .el-button {
      margin: 0;
    }
    .read-content {
      display: none
    }
    .read-header .el-button {
      border: none;
      padding-left: 0;
    }
    .read-title{
      display: none;
    }
    .read-title.mobile-title{
      display: block;
      margin: 0;
      text-align: left;
    }
    .read-button.left{
      right: 0;
      left: auto;
    }
    .share-list{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/read.vue